      <template>
	      <div style="display: block;background-color: rgb(50, 115, 245)">
		      <el-image  style="width: 100%;background-color: rgb(50, 115, 245)" v-for="url in urls" :key="url.name" :src="url.path" lazy></el-image>
	      </div>
   </template>
   
      <script>
   export default {
     data() {
       return {
	          urls: [
     {
       name: '图一',
       path: require('@/assets/背景1.jpg') // 使用@别名
     },
     {
       name: '图二',
       path: require('@/assets/背景2.jpg')
     },
     {
       name: '图三',
       path: require('@/assets/背景3.jpg')
     }
   ]
   
       };
     }
   };
   </script>
   